import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ExternalIntegration } from "types/generated";

const BackstageIntegrationTableDescriptionCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={integration.description} />
    </TableSimpleCell>
  );
};

export default BackstageIntegrationTableDescriptionCell;
